import { gql } from '@mineko/graphql-client';

export default gql`
  query Profile($input: ProfileInput) {
    Profile(input: $input) {
      email
      firstName
      lastName
    }
  }
`;
